import axios from 'axios';
import router from '../router'
import { EventBus } from '../main'
import Vue from 'vue'

export default {
    methods: {
        /*
        * Post Mixed
        * */
        async readMixed (data) {
            // EventBus.$emit('show-loading', true);
            return await axios
                .post('/lists/mixed', data)
                .then(response => {
                    // EventBus.$emit('show-loading', false);
                    return response.data
                })
                .catch(error => {
                    // EventBus.$emit('show-loading', false);
                    Vue.prototype.$generalAPIErrorHandling(error, router);
                })
        },
    }
}
